import React from 'react';
import { TvIcon } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-zinc-950 border-t border-zinc-800 py-10" data-id="element-112">
      <div className="max-w-4xl mx-auto px-4" data-id="element-113">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-114">
          <TvIcon className="w-6 h-6 text-emerald-500" data-id="element-115" />
          <span className="text-white font-bold" data-id="element-116">Guía Magis TV 2025</span>
        </div>

        {/* Legal disclaimer */}
        <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 mb-8" data-id="element-117">
          <p className="text-zinc-500 text-sm text-center leading-relaxed" data-id="element-118">
            <strong className="text-zinc-400" data-id="element-119">Aviso Legal:</strong> Esta guía es
            de carácter educativo-técnico y tiene como objetivo enseñar el
            proceso de instalación de aplicaciones en dispositivos Android. El
            usuario es responsable del uso que haga de la aplicación conforme a
            las leyes de su país. No promovemos ni incentivamos el uso ilegal de
            contenido protegido por derechos de autor.
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-6 text-sm text-zinc-500 mb-6" data-id="element-120">
          <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-121">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-122">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-123">
            Contacto
          </a>
        </div>

        {/* Copyright */}
        <p className="text-center text-zinc-600 text-sm" data-id="element-124">
          © 2025 Guía Magis TV. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}